import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    const label = event.currentTarget
    const checkbox = label.querySelector('input[type="checkbox"]')

    if (checkbox.checked) {
      label.classList.add("selected")
    } else {
      label.classList.remove("selected")
    }
  }
}
